import React, { Component } from "react";
import { Grid, Header, Segment, Image } from "semantic-ui-react";

import FormsResetPasswordEmail from "../../component/forms/password/reset";

import AppLogo from "../../component/logo";
class ResetPasswordEmailPage extends Component {
  render() {
    return (
      <div className="login-form">
        <Grid
          textAlign="center"
          style={{ height: "100%" }}
          verticalAlign="middle">
          <Grid.Column style={{ maxWidth: 450 }}>
            <Header as="h1" textAlign="center">
              <Image
                src="https://mplify.mhcasia.net/mhc_logo.jpg"
                size="huge"
              />
            </Header>

            <Header as="h2" textAlign="center">
              Reset Your Password
            </Header>

            <Segment stacked>
              <FormsResetPasswordEmail />
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export default ResetPasswordEmailPage;
